import React from 'react';

const DashboardHome = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>

            <img className="img-fluid" src="https://i.ibb.co/Vv4bKNQ/dashboard.jpg" alt="" />
        </div>
    );
};

export default DashboardHome;